import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";

export const chatPageService = {
  useCases: async () => {
    const response = await makeApiRequest({
      endpoint: API_ENDPOINTS.GET_USE_CASES,
      method: "POST",
      data: {
        companyID: localStorage.getItem("companyId") || "0",
        userID: localStorage.getItem("userId") || "0",
      },
      accessToken: localStorage.getItem("accessToken"),
    });
    if (response.data) {
      return response.data;
    } else {
      return [
        {
          id: "hr",
          title: "Human Resources",
          desc: "Query policies, benefits, and employee guidelines.",
          icon: "Users",
        },
        {
          id: "acc",
          title: "Accounting & Finance",
          desc: "Analyze Q4 reports, invoices, and ledgers.",
          icon: "PieChart",
        },
        {
          id: "ops",
          title: "Operations",
          desc: "Review production metrics and supply chain.",
          icon: "Briefcase",
        },
      ];
    }
  },

  startNewChat: async (useCaseId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.START_CHAT,
        method: "POST",
        data: {
          companyId: localStorage.getItem("companyId") || "0",
          usecaseId: useCaseId,
          userId: localStorage.getItem("userId"),
        },
        accessToken: localStorage.getItem("accessToken"),
      });
      if (response.data) {
        console.log("Chat started successfully:", response.data);
        return response.data;
      }
    } catch (error) {
      console.log("Start chat error:", error);
      throw error;
    }
  },

  fetchChatHistory: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_CHAT_HISTORY,
        method: "GET",
        accessToken: localStorage.getItem("accessToken"),
      });
      if (response.data) {
        console.log("Chat history fetched successfully:", response.data);
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.log("Fetch chat history error:", error);
      throw error;
    }
  },

  getChatMessages: async (conversationId) => {
    try {
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.GET_CHAT_MESSAGES}${conversationId}`,
        method: "GET",
        accessToken: localStorage.getItem("accessToken"),
      });
      console.log("historyMessageApi response:", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log("Get chat messages error:", error);
      throw error;
    }
  },

  sendMessage: async (message, userUseCaseId, conversationId, modelGroupId) => {
    try {
      const formData = new URLSearchParams();
      formData.append("message", message);
      formData.append("userUsecaseId", userUseCaseId);
      formData.append("modelGroupId", modelGroupId || "");
      // Keep both key variants for backend compatibility.
      // formData.append("userUseCaseId", userUseCaseId);
      if (
        conversationId !== null &&
        conversationId !== undefined &&
        conversationId !== ""
      ) {
        formData.append("conversationId", conversationId);
      }

      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.SEND_MESSAGE}`,
        method: "POST",
        data: formData,
        contentType: "form",
        accessToken: localStorage.getItem("accessToken"),
      });
      const payload = response?.data || response?.Data || {};
      const result = payload?.result || payload?.Result || {};
      const tokens =
        Number(result?.meta?.tokensUsed?.totalTokens) ||
        Number(result?.meta?.tokensUsed?.outputTokens) ||
        Number(result?.Meta?.TokensUsed?.OutputTokens) ||
        Number(result?.Meta?.TokensUsed?.TotalTokens) || 
        0;

      return {
        conversationId:
          Number(payload?.conversationId || payload?.ConversationId) ||
          Number(result?.meta?.conversationId || payload?.ConversationId) ||
          Number(conversationId || 0),
        messageText:
          result?.message ||
          payload?.response ||
          payload?.message ||
          payload?.Message ||
          result?.Message ||
          "No response returned.",
        tokensUsed: tokens,
        downloads: result?.downloads || result?.Downloads || [],
        table: result?.table || result?.Table || null,
        chart: result?.chart || result?.Chart
          ? {
              spec: result?.chart?.spec || result?.Chart?.Spec || null,
              data: result?.chart?.data || result?.Chart?.Data || null,
            }
          : null,
        sources: result?.sources || result?.Sources || [],
        meta: result?.meta || result?.Meta || {},
      };
    } catch (error) {
      console.log("Send message error:", error);
      throw error;
    }
  },

  pinChat: async (conversationID, isPinned) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.PIN_CHAT,
        method: "POST",
        data: { conversationID, isPinned, modifiedBy: localStorage.getItem("userId") },
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Pin chat error:", error);
      throw error;
    }
  },

  renameChat: async (conversationID, title) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.RENAME_CHAT,
        method: "POST",
        data: { conversationID, title, modifiedBy: localStorage.getItem("userId") },
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Rename chat error:", error);
      throw error;
    }
  },

  deleteChat: async (conversationID) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_CHAT,
        method: "POST",
        data: { conversationID, modifiedBy: localStorage.getItem("userId") },
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Delete chat error:", error);
      throw error;
    }
  },

  archiveChat: async (conversationID, isArchived) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.ARCHIVE_CHAT,
        method: "POST",
        data: { conversationID, isArchived, modifiedBy: localStorage.getItem("userId") },
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Archive chat error:", error);
      throw error;
    }
  },

  shareChat: async (conversationID) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.SHARE_CHAT,
        method: "POST",
        data: { conversationID, modifiedBy: localStorage.getItem("userId") },
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Share chat error:", error);
      throw error;
    }
  },

  getSharedChats: async (shareId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_SHARED_CHATS,
        data: {shareId},
        method: "POST",
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Get shared chats error:", error);
      throw error;
    }
  },

  updateConversationModelGroup: async (conversationId, modelGroupId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_CHAT_MODEL,
        method: "POST",
        data: { conversationId, modelGroupId, userId: Number(localStorage.getItem("userId")) },
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.log("Update conversation model group error:", error);
      throw error;
    }
  },
};